import { useState, useEffect } from 'react';

export interface ProjectPersonnel {
  id: string;
  index: string;
  name: string;
  avatar: string;
  badges?: string[];
  role: string;
  unit: string;
  type: string;
  typeColor: string;
  startDate: string;
  endDate: string;
  workHours: number;
  status: string;
  statusColor: string;
}

export function useProjectPersonnel() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        kpis: [
          { label: 'Tổng số nhân sự', value: 36, unit: 'người', icon: 'ri-group-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
          { label: 'Nhân sự nội bộ', value: 18, unit: 'người', percent: 50, icon: 'ri-user-settings-line', color: 'text-blue-500', bg: 'bg-blue-50' },
          { label: 'Nhân sự nhà thầu', value: 16, unit: 'người', percent: 44, icon: 'ri-user-shared-line', color: 'text-amber-500', bg: 'bg-amber-50' },
          { label: 'Tư vấn / Giám sát', value: 2, unit: 'người', percent: 6, icon: 'ri-user-star-line', color: 'text-rose-500', bg: 'bg-rose-50' },
          { label: 'Tổng giờ công', value: '3.258', unit: 'giờ', subtitle: 'Tháng 5/2024', icon: 'ri-time-line', color: 'text-sky-500', bg: 'bg-sky-50' },
          { label: 'Chi phí nhân sự', value: '1.685.200.000', unit: 'VND', percent: 24, subtitle: 'tổng chi phí', icon: 'ri-money-dollar-circle-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
        ],
        personnel: [
          { id: '1', index: '01', name: 'Nguyễn Văn An', avatar: 'https://i.pravatar.cc/150?u=4', badges: ['QLDA'], role: 'Quản lý dự án', unit: 'CP EcoLand', type: 'Nội bộ', typeColor: 'bg-blue-50 text-blue-600', startDate: '01/04/2024', endDate: '30/09/2024', workHours: 168, status: 'Đang làm việc', statusColor: 'bg-emerald-50 text-emerald-600' },
          { id: '2', index: '02', name: 'Trần Minh Tuấn', avatar: 'https://i.pravatar.cc/150?u=1', role: 'Chỉ huy trưởng', unit: 'CP EcoLand', type: 'Nội bộ', typeColor: 'bg-blue-50 text-blue-600', startDate: '01/04/2024', endDate: '30/09/2024', workHours: 176, status: 'Đang làm việc', statusColor: 'bg-emerald-50 text-emerald-600' },
          { id: '3', index: '03', name: 'Lê Hoàng Nam', avatar: 'https://i.pravatar.cc/150?u=2', role: 'Giám sát kỹ thuật', unit: 'CP EcoLand', type: 'Nội bộ', typeColor: 'bg-blue-50 text-blue-600', startDate: '01/04/2024', endDate: '30/09/2024', workHours: 176, status: 'Đang làm việc', statusColor: 'bg-emerald-50 text-emerald-600' },
          { id: '4', index: '04', name: 'Phạm Văn Tài', avatar: 'https://i.pravatar.cc/150?u=3', role: 'Giám sát hiện trường', unit: 'GreenBuild Co., Ltd', type: 'Nhà thầu', typeColor: 'bg-amber-50 text-amber-600', startDate: '05/04/2024', endDate: '30/09/2024', workHours: 184, status: 'Đang làm việc', statusColor: 'bg-emerald-50 text-emerald-600' },
          { id: '5', index: '05', name: 'Hoàng Văn Dũng', avatar: 'https://i.pravatar.cc/150?u=5', role: 'Tổ trưởng thi công', unit: 'GreenBuild Co., Ltd', type: 'Nhà thầu', typeColor: 'bg-amber-50 text-amber-600', startDate: '05/04/2024', endDate: '30/09/2024', workHours: 176, status: 'Đang làm việc', statusColor: 'bg-emerald-50 text-emerald-600' },
        ],
        contractors: [
          { id: '1', name: 'GreenBuild Co., Ltd', count: 16 },
          { id: '2', name: 'Landscape Pro Co., Ltd', count: 3 },
          { id: '3', name: 'Plant Care Co., Ltd', count: 1 },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
